import { Button, Col, Form, Input, Row } from "antd";
import { useState } from "react";
import { obtenerOrdenDePagoPorNroSiniestro } from "../../services/services";
import OrdenesDePagoTable from "../ordenes-table/ordenes-table";
import { messages } from "./ordenes-pago-siniestro.messages";

const colLayout = { xs: 24, sm: 24, md: 12, lg: 8 };


const OrdenesDePagoSiniestroResults = ({ data, loadingData, nroSiniestro }) => {

	const { loading: loadingMessage, noResults, results } = messages;

	const infoMessage = noResults(nroSiniestro);
	const successMessage = results(nroSiniestro, data?.length);

	const spinning = !data || loadingData;

	return (
            <OrdenesDePagoTable 
				loading={spinning} 
				loadingMessage={loadingMessage} 
				data={data} 
				infoMessage={infoMessage}
				successMessage={successMessage} 
			/>
	)
};

const OrdenesDePagoSiniestro = () => {
	const [form] = Form.useForm();

	const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
	const [data, setData] = useState(null);

	const onSubmit = async (values) => {
		console.log(values);
		setLoading(true);
		setError(null);
		try {
			const response = await obtenerOrdenDePagoPorNroSiniestro({NroSiniestro: values.nroSiniestro});
			const data = await response.json();
			setData(data.data);
		} catch (error) {
			setError(error);
		} finally {
			setLoading(false);
		}
	};

	const nroSiniestro = form.getFieldValue('nroSiniestro');

    return (
        <div className='content'>
            <h4>Ordenes de pago por Nro siniestro</h4>
            <Form form={form}
			  layout='vertical'
			  requiredMark={false}
			  onFinish={onSubmit}
			  >
				    {/* <Spin tip='Cargando...' spinning={loading}> */}
                        <Row gutter={[16]}>
                            <Col {...colLayout} lg={6}>
                                <Form.Item
                                    label='Nro siniestro'
                                    name='nroSiniestro'
                                    validateTrigger={false}
                                    rules={[{ required: true, message: 'Por favor ingrese el nro siniestro' }]}
                                >
                                    <Input size='medium' />
                                </Form.Item>
                            </Col>
                            <Col {...colLayout} lg={4}>
                                <div style={{ marginTop: "30px" }}>
                                    <Button
                                        block
                                        htmlType='submit'
                                        size='medium'
										disabled={loading}
										// loading={loading}
                                    >
                                        CONSULTAR
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    {/* </Spin> */}
            </Form>

			{data && <OrdenesDePagoSiniestroResults 
						data={data} 
						loadingData={loading}
						nroSiniestro={nroSiniestro} 
					/>
			}
        </div>
    );
};

export default OrdenesDePagoSiniestro;